<template>
    <div class="vote" v-loading='proloading'>
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div></div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">
                            新增问题
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <el-table :data="proData" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="vote_name" type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="problem" label="问题" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="create_time" label="类型" width="80">
                <template slot-scope="scope">
                    <span>{{({1:'单选',2:'多选',3:'填空'})[scope.row.choose_type]}}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="create_time" label="选项" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div>
                        <span v-for="(op,ind) in scope.row.options" :key="ind">
                            <span style="color:red">{{ind+1}}.</span>{{op.option}}
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                        @click="handleEdit(scope.row,scope.$index)"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-delete"
                        @click="handleDelet(scope.row,scope.$index)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新建" :visible.sync="adddialogVisible" top="50px" width="50%" class="dialogs" append-to-body>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="problems" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <div class="problem_box">
                        <!-- <el-form-item label="类型" style="margin-top:10px" prop="problem">
                            <el-radio-group v-model="ruleForm.choose_type">
                                <el-radio :label="1">单选</el-radio>
                                <el-radio :label="2">多选</el-radio>
                                <el-radio :label="3">填空</el-radio>
                            </el-radio-group>
                        </el-form-item> -->
                        <el-form-item label="标题" style="margin-top:10px" prop="problem">
                            <el-input v-model="ruleForm.problem" size="small"></el-input>
                        </el-form-item>
                        <div>
                            <el-form-item :label="'选项'+(ind+1)" v-for="(o,ind) in ruleForm.options" :key="ind"
                                style="margin-top:15px" required>
                                <el-row :gutter="10">
                                    <el-col :span="16">
                                        <el-input v-model="o.option" style="max-width:380px" size="small"></el-input>
                                        分值
                                        <el-input v-model="o.score" style="width:55px" size="small"></el-input>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-button size="mini" type="success" @click="addpro(o)">添加</el-button>
                                        <el-button size="mini" v-if="ind!=0" type="danger" @click="delpro(o)">删除
                                        </el-button>
                                        <!-- <el-button size="mini" v-if="ruleForm.choose_type==2&&ruleForm.options.length==(ind+1)" type="text" @click="togtype(o)"><i :style="{color:o.option_type==1?'':'red'}" class="el-icon-edit"></i>
                                        </el-button> -->
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">确 定
                </el-button>
                <el-button @click="adddialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                proData: [],
                textId: '',
                loading: false,
                subloading: false,
                height: null,
                adddialogVisible: false,
                ruleForm: {
                    problem: "",
                    // choose_type: 1,
                    options: [{
                        option: "",
                        // option_type: 1,
                        score: '',
                    }, ]
                },
                problems: {
                    problem: [{
                        required: true,
                        message: '问题必填',
                        trigger: 'blur'
                    }, ],
                    option: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],
                },
                eid: '',
                proloading: false,
            }
        },
        mounted() {
            this.getHeight()
            // this.getlist()

        },
        methods: {
            getHeight() {
                let that = this

                that.height = window.innerHeight - 175 + 'px'
                window.onresize = () => {

                    that.height = window.innerHeight - 175 + 'px'
                }
            },
            handleAdd() {
                this.clearf()
                this.eid = ''
                this.adddialogVisible = true
            },
            clearf() {
                this.ruleForm = {
                    problem: "",
                    // choose_type: 1,
                    options: [{
                        option: "",
                        // option_type: 1,
                        score: '',
                    }]
                }
            },
            getlist(id) {
                this.proData=[]
                this.proloading = true
                axios
                    .post("/admin/questionProblem/problemList", {
                        testpaper_id: id,
                        page: 1,

                    }, {
                        token: true
                    })
                    .then(response => {
                        this.proloading = false

                        if (response.data.code == '200') {
                            this.proData = response.data.data
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            handleEdit(row, index) {
                this.ruleForm.problem = row.problem
                this.ruleForm.options = []
                row.options.forEach(ele => {
                    this.ruleForm.options.push({
                        option: ele.option,
                        score: ele.score+'',
                        id:ele.id,
                        create_author: ele.create_author,
                    })
                })
                if (row.options.length == 0) {
                    this.ruleForm.options = [{
                        option: "",
                        score: '',
                    }]
                }
                this.eid = row.id
                this.adddialogVisible = true
            },
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该问题, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.proloading = true
                    axios
                        .post("/admin/questionProblem/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist(this.textId)
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            delpro(item) {
                var index = this.ruleForm.options.indexOf(item)
                if (index !== -1) {
                    this.ruleForm.options.splice(index, 1)
                }
            },
            addpro(p) {
                this.ruleForm.options.push({
                    option: "",
                    // option_type: 1,
                    score: '',
                })
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let op_null = false
                        this.ruleForm.options.forEach(ele => {
                            if (ele.option == '' || (ele.score=='')) {
                                op_null = true
                                return
                            }
                        })
                        if (op_null) return this.$message.error('选项填写完整')
                        let urls
                        if (this.eid && this.eid != '') {
                            urls = "/admin/questionProblem/update"
                        } else {
                            urls = "/admin/questionProblem/save"
                        }
                        this.subloading = true
                        axios.post(urls, {
                                id: that.eid,
                                testpaper_id: this.textId,
                                ...this.ruleForm,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.adddialogVisible = false
                                    that.getlist(this.textId)
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        // this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            togtype(o) {
                if (o.option_type == 1) {
                    o.option_type = 2
                } else {
                    o.option_type = 1
                }
            },
        },
        watch: {
            'ruleForm.choose_type'(val, old) {
                if (val == 3) {
                    this.ruleForm.options = [{
                        option: "",
                        // option_type: 1,
                        score: '',
                    }]
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .add_tits {
        padding: 0 10px;
    }
</style>